import { useWorkspaceNavigation } from "@workspace/useWorkspaceNavigation";

import { isOnTodayBoard } from "./visitStatus";

interface OpenVisitParams {
  visitUuid: string;
  patientUuid: string;
  patientName: string | null;
  clientName?: string | null;
  scheduledStart: string | null;
  currentRoomUuid?: string | null;
}

/**
 * Mirrors the search modal: a visit on today's board opens as a visit selection
 * (rich pane); any other day has no entry in the today-centric workspace, so the
 * patient opens as an overlay subject instead. Decided off the visit's own date —
 * the today query isn't mounted under `/calendar`, so its cache may be absent or
 * garbage-collected.
 *
 * Both branches navigate to `/`, whose validateSearch keeps only the four workspace
 * params, so the calendar's `?week=` is dropped either way. `openSubject` clears any
 * room/visit as it opens (a full navigation, not an overlay), so nothing stale is
 * left behind.
 */
export const useOpenVisit = () => {
  const { selectVisit, openSubject } = useWorkspaceNavigation();

  const openVisit = ({
    visitUuid,
    patientUuid,
    patientName,
    clientName,
    scheduledStart,
    currentRoomUuid,
  }: OpenVisitParams) => {
    if (isOnTodayBoard(scheduledStart)) {
      selectVisit(visitUuid, currentRoomUuid ?? null);
    } else {
      openSubject({
        id: patientUuid,
        name: patientName ?? "Patient",
        kind: "patient",
        clientName: clientName ?? undefined,
      });
    }
  };

  return openVisit;
};
